import type { Delete } from 'mdast';
import type { State } from '../state';

/**
 * Handle mdast `delete` node (GFM strikethrough ~~text~~).
 *
 * Maps to a `strike` or `strikethrough` mark if the schema has one.
 * If the schema has no such mark, the content is rendered without the mark
 * (graceful degradation — content is preserved, styling is lost).
 */
export function deleteNode(state: State, node: Delete): void {
	const markType = state.schema.marks.strike ?? state.schema.marks.strikethrough;
	if (markType) {
		const mark = markType.create();
		state.openMark(mark);
		state.parseTokens(node.children);
		state.closeMark(mark);
	} else {
		// Graceful degradation: render content without mark
		state.parseTokens(node.children);
	}
}
